<app-tab-navigation-header
	title="Client"
	i18n-title="@@clientMainTab-clientTitle"
	[detail]="!isClientLoaded ? '' : clientName"
>
	<mat-tab-group appQueryStringTabGroup>
		<mat-tab
			[label]="!isClientLoaded ? '' : 'Details'"
			i18n-label="@@clientMainTab-details"
			data-automation-id="client-details-tab"
		>
			<ng-template matTabContent>
				@if (isClientLoaded) {
					<app-client-about
						[appBreadcrumbLabel]="!isClientLoaded ? '' : clientName"
						(updateClientDetails)="getInitialData()"
					></app-client-about>
				}
			</ng-template>
		</mat-tab>
		<mat-tab
			[label]="!isClientLoaded ? '' : 'Properties'"
			i18n-label="@@clientMainTab-properties"
			data-automation-id="client-properties-tab"
		>
			<ng-template matTabContent>
				<app-property-list-table
					[appBreadcrumbLabel]="!isClientLoaded ? '' : propertyBreadcrumbLabel"
					[hideToolbar]="true"
					[hidePendingInstalls]="true"
					[swapDevicesAndStatus]="true"
					[propertyDataRequest]="clientPropertyDataRequest"
				>
				</app-property-list-table>
			</ng-template>
		</mat-tab>
		<mat-tab
			[label]="!isClientLoaded ? '' : 'Devices'"
			i18n-label="@@clientMainTab-devices"
			data-automation-id="client-devices-tab"
		>
			<ng-template matTabContent>
				<app-all-devices
					[appBreadcrumbLabel]="!isClientLoaded ? '' : devicesBreadcrumbLabel"
					[hideToolbar]="true"
					[deviceDataRequest]="filteredDevicesByClientProperty"
				>
				</app-all-devices>
			</ng-template>
		</mat-tab>
		@if (canAccessAuditLogs) {
			<mat-tab
				[label]="!isClientLoaded ? '' : 'Audit Logs'"
				i18n-label="@@clientMainTab-auditLogs"
				data-automation-id="client-audit-logs-tab"
			>
				<ng-template matTabContent>
					<app-audit-log-list
						[clientId]="clientId"
						[appBreadcrumbLabel]="!isClientLoaded ? '' : auditLogBreadcrumbLabel"
						[hiddenColumns]="hiddenAuditLogColumns"
					></app-audit-log-list>
				</ng-template>
			</mat-tab>
		}
	</mat-tab-group>
</app-tab-navigation-header>
